<template>
    <div>
        <div class="list-item">
            <div class="item-publish" :class="!strategyIsPublish ? 'no_publish' : 'yes_publish'"></div>
            <div class="item-left">
                <div class="item-logo">
                    <router-link :to="'/strategysquare/' + strategyId" :key="strategyId">
                        <img :src="'/svg/' + strategyId + '.svg'">
                    </router-link>
                </div>
            </div>
            <div class="item-right">
                <div class="item-right-t">
                    <div class="item-details">
                        <router-link :to="'/strategysquare/' + strategyId" :key="strategyId">
                            <h3 @click="buriedPoints">{{strategyName}}</h3>
                        </router-link>
                        <div class="item-label">
                            <span v-for="(item, index) in strategyTags" :key="index" v-if="item">{{item}}</span>
                        </div>
                        <p><b>投资逻辑：</b>{{strategyLogic}}</p>
                    </div>
                    <div class="item-subscribe" style="border:none;" v-if="!strategyIsPublish"></div>
                    <div class="item-subscribe" v-if="isSubscribe && strategyIsPublish" @click="subscribe">订阅</div>
                    <div class="item-subscribe" v-if="!isSubscribe && strategyIsPublish" @click="cancelSubscribe">取消订阅</div>
                    <div class="item-annual-income">
                        <p :class="strategyAnnualYield | riseAndFallClass">{{strategyAnnualYield | safePercentFixedTwo}}</p>
                        <span>年化收益</span>
                    </div>
                    <div class="item-success-rate">
                        <p :class="strategyWinRate | riseAndFallClass">{{strategyWinRate | safePercentFixedTwo}}</p>
                        <span>成功率</span>
                    </div>
                    <div class="item-user">
                        <div class="item-user-img right">
                            <img :src="strategyAvatar">
                        </div>
                        <p class="right">{{strategyUser}}</p>
                    </div>
                </div>
                <div class="item-right-b">
                    <div class="item-comment" v-if="!isshoworder">
                        <span>评论({{strategyCommentNum}})</span>
                    </div>
                    <div class="item-collect" v-if="!isshoworder">
                        <div class="item-collect">
                            <span>收藏数({{strategyCollectNum}})</span>
                        </div>
                    </div>
                    <div class="item-delete" @click="deleteStrategy(strategyId)">
                        <span>删除</span>
                    </div>
                    <div class="item-set-date">
                        <span>创建时间：{{strategyCtime}}</span>
                    </div>
                </div>

                <pickstock
                    v-if="!isshoworder && isPickCompleted"
                    :transactiontype="'' + strategyType"
                    :select-data="pickData"
                    :classname="'item-stock-list'"
                    :buy-position="parseInt(buyPosition)">
                </pickstock>


            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-new */
    import axios from 'axios'
    import pickstock from '../strategybacktest/strategy-select'
    export default {
        name: 'strategy-row-item',
        components: {
            pickstock: pickstock
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.myStrategy.createdStrategy
            }
        },
        data () {
            return {
                myBarOption: {
                    barWidth: 9, // 滚动条宽度
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    horizrailenabled: false // 是否显示水平滚动条
                },
                isshoworder: false,
                isPickCompleted: false,
                pickData: null,
                isSubscribe: false
            }
        },
        filters: {
            closePrices (num) {
                return !num ? '--' : Number(num)
            }
        },
        methods: {
            buriedPoints () {
                window.TA.log({id: this.buriedPoint.inStrategyDetails, targid: this.strategyId})
            },
            deleteStrategy (id) {
                let self = this
                window.TA.log(this.buriedPoint.delete)
                this.$confirm({
                    // 'type': 'warning',
                    'title': '您要删除该策略吗？',
                    // 'smallTitle': '取消后，我们不再推送给你该机器人的股票操作信息',
                    'okBtnTitle': '确定',
                    'cancelBtnCallback': function (done) {
                        window.TA.log(self.buriedPoint.deleteCancel)
                        done()
                    },
                    'okBtnCallback': function (done) {
                        window.TA.log(self.buriedPoint.deleteOk)
                        axios.post('/strategysquare/delete', {
                            strategyId: id
                        }).then((res) => {
                            if (!res.data.result) {
                                self.$tip({
                                    message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                                    duration: 2000,
                                    type: 'error'
                                })
                            } else {
                                self.$emit('delete-strategy')
                                done()
                                self.$tip({
                                    message: '策略删除成功',
                                    duration: 2000,
                                    type: 'success'
                                })
                            }
                        }).catch((error) => {
                            done()
                            self.$tip({
                                message: error ? error.message : '网络异常',
                                duration: 2000,
                                type: 'error'
                            })
                        })
                    }
                })
            },
            subscribe () {
                var self = this
                window.TA.log({id: this.buriedPoint.subscribe, targid: this.strategyId})
                axios.get('/mybacktest/subscribe', {params: {
                    id: this.strategyId
                }}).then((res) => {
                    if (res.data.errorcode) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    } else {
                        this.$emit('subscribe')
                        self.$tip({
                            message: '策略订阅成功',
                            duration: 2000,
                            type: 'success'
                        })
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            cancelSubscribe () {
                var self = this
                window.TA.log(this.buriedPoint.cancelSubscribe)
                axios.get('/mybacktest/cancelsubscribe', {params: {
                    id: this.strategyId
                }}).then((res) => {
                    if (!res.data.result) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    } else {
                        this.$emit('cancel-subscribe')
                        self.$tip({
                            message: '策略取消订阅成功',
                            duration: 2000,
                            type: 'success'
                        })
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            showTodayStock () {
                var self = this
                axios.get('/strategysquare/pickstock', {params: {
                    strategyId: this.strategyId
                }
                }).then((res) => {
                    return res.data.result
                }).then((data) => {
                    this.isPickCompleted = true
                    if (!data) {
                        self.$tip({
                            message: '获取选股参数有误',
                            duration: 2000,
                            type: 'error'
                        })
                    } else {
                        this.pickData = data
                    }
                }).catch(function (error) {
                    self.isPickCompleted = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        mounted () {
            if (this.strategyIsSubscribe === 1) {
                this.showTodayStock()
                this.isshoworder = false
                this.isSubscribe = false
            } else {
                this.isshoworder = true
                this.isSubscribe = true
            }
        },
        watch: {
            strategyIsSubscribe (val) {
                if (val === 1) {
                    this.showTodayStock()
                    this.isshoworder = false
                    this.isSubscribe = false
                } else {
                    this.isshoworder = true
                    this.isSubscribe = true
                }
            }
        },
        props: {
            strategyId: {
                type: Number,
                default: ''
            },
            buyPosition: Number,
            strategyType: {
                type: Number,
                default: 0
            },
            strategyName: {
                type: String,
                default: ''
            },
            strategyLogic: {
                type: String,
                default: ''
            },
            strategyCtime: {
                type: String,
                default: ''
            },
            strategyAnnualYield: {
                type: String,
                default: '0.00%'
            },
            strategyWinRate: {
                type: String,
                default: '0.00%'
            },
            strategyTags: {
                type: Array,
                default: []
            },
            strategyUser: {
                type: String,
                default: ''
            },
            strategyAvatar: {
                type: String,
                default: ''
            },
            strategyCollectNum: {
                type: Number,
                default: 0
            },
            strategyCommentNum: {
                type: Number,
                default: 0
            },
            strategyIsSubscribe: {
                type: Number,
                default: 0
            },
            strategyIsPublish: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/strategy-row-item.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/strategy-row-item.vue